import { classNames } from '@ui-components-3/ui'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

const AvailabilityLegend = () => {
  const { t } = useTranslation()

  const legendItems = useMemo(
    () => [
      {
        colorClassName: 'bg-neutral-300',
        label: t('operatingHours.modal.unavailable'),
        colorLabel: t('common.colors.grey'),
      },
      {
        colorClassName: 'bg-secondary-600',
        label: t('operatingHours.modal.available'),
        colorLabel: t('common.colors.teal'),
      },
    ],
    [t],
  )

  return (
    <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2 px-4 py-2 sm:gap-x-6 sm:px-6 sm:py-3">
      {legendItems.map(({ label, colorClassName, colorLabel }) => (
        <div
          key={label}
          className="typography-small flex items-center justify-center gap-2 text-neutral-600"
          aria-label={`${colorLabel} - ${label}`}
        >
          <span className={classNames('h-3 w-3 rounded-full', colorClassName)} aria-hidden="true" />
          <span aria-hidden="true">{label}</span>
        </div>
      ))}
    </div>
  )
}

export default AvailabilityLegend
